import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const PrinterIcon = createSvgIcon(
  <>
    <rect width="24" height="24" fill="var(--background-paper)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 3C6.94772 3 6.5 3.44772 6.5 4V6H17.5V4C17.5 3.44772 17.0523 3 16.5 3H7.5ZM19.5 6V4C19.5 2.34315 18.1569 1 16.5 1H7.5C5.84315 1 4.5 2.34315 4.5 4V6H4C2.34315 6 1 7.34315 1 9V15C1 16.6569 2.34315 18 4 18H5V20C5 21.6569 6.34315 23 8 23H16C17.6569 23 19 21.6569 19 20V18H20C21.6569 18 23 16.6569 23 15V9C23 7.34315 21.6569 6 20 6H19.5ZM20 16C20.5523 16 21 15.5523 21 15V9C21 8.44772 20.5523 8 20 8H4C3.44772 8 3 8.44772 3 9V15C3 15.5523 3.44772 16 4 16H5V14.5C4.44772 14.5 4 14.0523 4 13.5C4 12.9477 4.44772 12.5 5 12.5H19C19.5523 12.5 20 12.9477 20 13.5C20 14.0523 19.5523 14.5 19 14.5V16H20ZM17 14.5H7V20C7 20.5523 7.44772 21 8 21H16C16.5523 21 17 20.5523 17 20V14.5ZM8.5 18C8.5 17.4477 8.94772 17 9.5 17H14.5C15.0523 17 15.5 17.4477 15.5 18C15.5 18.5523 15.0523 19 14.5 19H9.5C8.94772 19 8.5 18.5523 8.5 18ZM5 9C4.44772 9 4 9.44771 4 10C4 10.5523 4.44772 11 5 11H7C7.55228 11 8 10.5523 8 10C8 9.44771 7.55228 9 7 9H5Z"
      fill="currentColor"
    />
  </>,
  "PrinterIcon"
);
